import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Grid, Box} from 'views/components';
import {Translate} from 'views/module';
import IconList from './IconList';

const Discover = (props) => {
  const activeIcons = props.activeIcons;

  return (
    <Box sx={{
    }}>
      <Grid container
        justifyContent="center"
        sx={{
          maxWidth: {md: '80vw'},
          mx: 'auto',
          mt: {xl: '60px', md: '8px', xs: '4px'},
        }}
      >
        <Grid item xs={12}
          sx={{
            mx: 'auto',
            width: '100%',
            maxWidth: {md: '1000px'},
          }}
        >
          <Typography
            variant='h4'
            sx={{
              textAlign: {md: 'left', xs: 'center'},
              py: {md: 2, xs: 0},
            }}
          >
            <Translate expression='generic.Discover' />
          </Typography>
          <IconList activeIcons={activeIcons}/>
        </Grid>
      </Grid>
    </Box>
  );
};

Discover.propTypes = {
  activeIcons: PropTypes.object,
};


export default Discover;
